<template>
  <div
    class="container_index"
    :style="{ width: screenWidth + 'px', height: screenHeight + 'px' }"
  >
    <div class="container_index-header">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
        "
      >
        <span style="font-size: 18px; margin-left: 0px">{{
          userInfo.permission === "超级管理员"
            ? "武术赛事报名系统"
            : eventInfo
            ? eventInfo.eventName
            : "武术赛事报名系统"
        }}</span>
      </div>
      <span
        v-if="eventInfo === null && userInfo.permission !== '超级管理员'"
        style="font-size: 13px; margin-right: 20px; color: red; font-size: 18px"
        >您还没有自己的赛事或赛事未审核通过,请先创建赛事!</span
      >
      <div class="right_box">
        <span
          v-if="userInfo.permission !== '超级管理员'"
          style="font-size: 13px; margin-right: 20px"
          >{{ jiezhiTime }}</span
        >
        <el-dropdown @click="logout" trigger="click">
          <span class="el-dropdown-link">
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <el-icon class="el-icon-user" style="color: white" />
              <span style="margin-left: 15px; color: white; cursor: pointer"
                >{{ userInfo.phone }}
              </span>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="$router.push('/userInfo')">个人资料</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="logout">退出</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span style="font-size: 12px; margin-left: 15px; color: white">{{
          userInfo.permission
        }}</span>
      </div>
    </div>
    <div class="container_index-tol">
      <div @click="clickMenuAction">
        <el-icon
          class="el-icon-s-unfold"
          style="font-size: 18px; cursor: pointer"
        />
      </div>
      <el-breadcrumb
        v-if="routerInfo.routeMenu"
        separator-class="el-icon-arrow-right"
        style="margin-left: 15px; width: 180px"
      >
        <template v-if="routerInfo.routeMenu.length > 0">
          <el-breadcrumb-item
            v-for="(item, index) in routerInfo.routeMenu"
            :key="index"
            :to="{ path: item.path }"
            >{{ item.name }}
          </el-breadcrumb-item>
        </template>
        <template>
          <el-breadcrumb-item>
            {{ routerInfo.name }}
          </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
      <span style="margin-left: 10px; color: red">报名顺序:</span>
      <el-breadcrumb separator="-->" style="margin-left: 20px">
        <el-breadcrumb-item :to="{ path: '/teamList' }">
          <span
            :style="{
              color: routerInfo.path === '/teamList' ? 'red' : '#000000',
            }"
            >1. 队伍信息</span
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/athleteList' }">
          <span
            :style="{
              color: routerInfo.path === '/athleteList' ? 'red' : '#000000',
            }"
            >2. 队员信息</span
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/joinCompetition' }">
          <span
            :style="{
              color: routerInfo.path === '/joinCompetition' ? 'red' : '#000000',
            }"
            >3. 项目填报</span
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/bmSummary' }">
          <span
            :style="{
              color: routerInfo.path === '/bmSummary' ? 'red' : '#000000',
            }"
            >4. 汇总下载</span
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>5. 下载缴费明细</el-breadcrumb-item>
        <el-breadcrumb-item>6. 缴费后即完成报名</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container_index-content">
      <div class="left">
        <el-menu
          class="el-menu-vertical-demo"
          :collapse="collapse"
          :router="true"
          :default-active="routerInfo.path"
          text-color="#555555"
          active-text-color="#409EFF"
          background-color="#ffffff"
        >
          <template v-for="(item, index) in sortedMenuList">
            <el-menu-item :key="index" :index="item.path">
              <el-icon :class="item.icon" />
              <span slot="title" style="font-size: 14px">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="right">
        <div class="content">
          <router-view :key="routeKey" class="content_sc" />
        </div>
        <div
          style="
            font-size: 13px;
            color: #555555;
            z-index: 999;
            margin-top: 30px;
          "
        >
          Copyright © 2024-2025 武术赛事报名系统
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import { getCompetition, getUser, getExportByUserId } from "@/api";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Index",
  data() {
    return {
      models: [],
      collapse: false,
      menuList: [],
      endTimeCountDownTimer: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isRunning: false,
      jiezhiTime: "",
      configKeyspermission: [],
    };
  },
  computed: {
    ...mapState([
      "userLogin",
      "userInfo",
      "routerInfo",
      "screenHeight",
      "screenWidth",
      "eventInfo",
    ]),
    routeKey() {
      // 使用路由路径和参数生成唯一key
      return (
        this.$route.path +
        JSON.stringify(this.$route.query) +
        moment().format("YYYY-MM-DD HH:mm:ss")
      );
    },
    sortedMenuList() {
      // 根据 sort 字段对菜单进行排序
      if (!this.menuList || this.menuList.length === 0) return [];
      return this.menuList.slice().sort((a, b) => {
        const sortA = a.sort !== undefined ? a.sort : Infinity;
        const sortB = b.sort !== undefined ? b.sort : Infinity;
        return sortA - sortB;
      });
    },
  },
  watch: {
    $route(to) {
      this.$store.dispatch("setRouterInfo", {
        name: to.name,
        routeMenu: to.meta.routeMenu,
        path: to.path,
      });
    },
  },
  mounted() {
    if (!this.userLogin) {
      this.$router.push("/");
    }
    if (this.userLogin) {
      getUser(this.userInfo.id).then((res) => {
        if (res.data.code === 200) {
          this.$store.dispatch("setUserInfo", res.data.result);
          if (
            res.data.result.permission === "赛事管理员" &&
            res.data.result.competitionId !== null
          ) {
            getCompetition(res.data.result.competitionId).then((res1) => {
              if (res1.data.code === 200) {
                this.$store.dispatch("setEventInfo", res1.data.result);
                this.endTimeCountDownTimer = setInterval(() => {
                  this.calculateCountdown();
                }, 1000);
              }
            });
          }
        }
      });
      if (this.eventInfo) {
        getCompetition(this.eventInfo.id).then((res1) => {
          if (res1.data.code === 200) {
            this.$store.dispatch("setEventInfo", res1.data.result);
            this.endTimeCountDownTimer = setInterval(() => {
              this.calculateCountdown();
            }, 1000);
          }
        });
      }
    }
    if (this.userInfo.permission === "赛事方查阅") {
      if (this.eventInfo === null) {
        this.menuList = [];
        return;
      }
      this.menuList = [
        {
          sort: 1,
          name: "代表队信息",
          path: "/teamList",
          icon: "el-icon-notebook-2",
        },
        {
          sort: 2,
          name: "运动员信息",
          path: "/athleteList",
          icon: "el-icon-s-data",
        },
        {
          sort: 3,
          name: "报名汇总",
          path: "/bmSummary",
          icon: "el-icon-date",
        },
        {
          sort: 4,
          name: "人数统计",
          path: "/userNumTj",
          icon: "el-icon-thumb",
        },
        {
          sort: 5,
          name: "通知公告",
          path: "/announcementList",
          icon: "el-icon-chat-square",
        },
        {
          sort: 6,
          name: "下载中心",
          path: "/attachmentList",
          icon: "el-icon-document",
        },
      ];
      this.addOrderToMenu();
    }
    if (this.userInfo.permission === "超级管理员") {
      this.menuList = [
        {
          sort: 1,
          name: "用户列表",
          path: "/userList",
          icon: "el-icon-user",
        },
        {
          sort: 2,
          name: "代表队信息",
          path: "/teamList",
          icon: "el-icon-notebook-2",
        },
        {
          sort: 3,
          name: "运动员信息",
          path: "/athleteList",
          icon: "el-icon-s-data",
        },
        {
          sort: 4,
          name: "项目填报",
          path: "/joinCompetition",
          icon: "el-icon-edit",
        },
        {
          sort: 5,
          name: "报名汇总",
          path: "/bmSummary",
          icon: "el-icon-date",
        },
        {
          sort: 6,
          name: "赛事管理",
          path: "/competitionList",
          icon: "el-icon-trophy",
        },
        {
          sort: 7,
          name: "缴费设置",
          path: "/paymentList",
          icon: "el-icon-money",
        },
        {
          sort: 8,
          name: "年龄组别",
          path: "/ageCategoryList",
          icon: "el-icon-sort",
        },
        {
          sort: 9,
          name: "项目类别",
          path: "/projectCategoryList",
          icon: "el-icon-s-grid",
        },
        {
          sort: 10,
          name: "通知公告",
          path: "/announcementList",
          icon: "el-icon-chat-square",
        },
        {
          sort: 11,
          name: "下载中心",
          path: "/attachmentList",
          icon: "el-icon-document",
        },
        {
          sort: 12,
          name: "人数统计",
          path: "/userNumTj",
          icon: "el-icon-thumb",
        },
        {
          sort: 13,
          name: "代表队名单",
          path: "/teamStatistic",
          icon: "el-icon-user",
        },
        {
          sort: 14,
          name: "集体编排",
          path: "/jtbianPai",
          icon: "el-icon-user",
        },
        {
          sort: 15,
          name: "套路编排",
          path: "/tlbianPai",
          icon: "el-icon-user",
        },
        {
          sort: 16,
          name: "年龄组别顺序配置",
          path: "/ageCategorySortConfig",
          icon: "el-icon-user",
        },
        {
          sort: 17,
          name: "项目类别顺序配置",
          path: "/projectCategorySortConfig",
          icon: "el-icon-user",
        },
        {
          sort: 18,
          name: "场地分配",
          path: "/addressSetConfig",
          icon: "el-icon-user",
        },
        {
          sort: 19,
          name: "场地分配表",
          path: "/addressList",
          icon: "el-icon-user",
        },
        {
          sort: 20,
          name: "竞赛日常表",
          path: "/competitionDataList",
          icon: "el-icon-user",
        },
        {
          sort: 21,
          name: "项目导出排版",
          path: "/exportConfig",
          icon: "el-icon-user",
        },
        {
          sort: 22,
          name: "数据格式调整",
          path: "/formatAdjustment",
          icon: "el-icon-user",
        },
        {
          sort: 23,
          name: "奖牌统计",
          path: "/medalConfig",
          icon: "el-icon-user",
        },
        {
          sort: 24,
          name: "编排权限设置",
          path: "/exportSettings",
          icon: "el-icon-user",
        },
      ];
    }
    if (this.userInfo.permission === "报名用户") {
      this.menuList = [
        {
          sort: 1,
          name: "首页",
          path: "/home",
          icon: "el-icon-user",
        },
        {
          sort: 2,
          name: "代表队信息",
          path: "/teamList",
          icon: "el-icon-notebook-2",
        },
        {
          sort: 3,
          name: "运动员信息",
          path: "/athleteList",
          icon: "el-icon-s-data",
        },
        {
          sort: 4,
          name: "项目填报",
          path: "/joinCompetition",
          icon: "el-icon-edit",
        },
        {
          sort: 5,
          name: "报名汇总",
          path: "/bmSummary",
          icon: "el-icon-date",
        },
        {
          sort: 6,
          name: "下载中心",
          path: "/attachmentList",
          icon: "el-icon-document",
        },
      ];
    }
    if (this.userInfo.permission === "赛事管理员") {
      if (this.eventInfo === null) {
        this.menuList = [
          {
            sort: 1,
            name: "赛事管理",
            path: "/competitionList",
            icon: "el-icon-trophy",
          },
        ];
        return;
      }
      this.menuList = [
        {
          sort: 1,
          name: "首页",
          path: "/home",
          icon: "el-icon-user",
        },
        {
          sort: 2,
          name: "用户列表",
          path: "/userList",
          icon: "el-icon-user",
        },
        {
          sort: 3,
          name: "队伍信息",
          path: "/teamList",
          icon: "el-icon-notebook-2",
        },
        {
          sort: 4,
          name: "队员信息",
          path: "/athleteList",
          icon: "el-icon-s-data",
        },
        {
          sort: 5,
          name: "项目填报",
          path: "/joinCompetition",
          icon: "el-icon-edit",
        },
        {
          sort: 6,
          name: "报名汇总",
          path: "/bmSummary",
          icon: "el-icon-date",
        },
        {
          sort: 7,
          name: "赛事管理",
          path: "/competitionList",
          icon: "el-icon-trophy",
        },
        {
          sort: 8,
          name: "缴费设置",
          path: "/paymentList",
          icon: "el-icon-money",
        },
        {
          sort: 9,
          name: "年龄组别",
          path: "/ageCategoryList",
          icon: "el-icon-sort",
        },
        {
          sort: 10,
          name: "项目类别",
          path: "/projectCategoryList",
          icon: "el-icon-s-grid",
        },
        {
          sort: 11,
          name: "通知公告",
          path: "/announcementList",
          icon: "el-icon-chat-square",
        },
        {
          sort: 12,
          name: "下载中心",
          path: "/attachmentList",
          icon: "el-icon-document",
        },
        {
          sort: 13,
          name: "人数统计",
          path: "/userNumTj",
          icon: "el-icon-thumb",
        },

        {
          sort: 15,
          name: "项目导出排版",
          path: "/exportConfig",
          icon: "el-icon-user",
        },
        {
          sort: 16,
          name: "数据格式调整",
          path: "/formatAdjustment",
          icon: "el-icon-user",
        },
        {
          sort: 17,
          name: "奖牌统计",
          path: "/medalConfig",
          icon: "el-icon-user",
        },
      ];
    }
    if (this.userInfo.permission === "赛事管理员") {
      this.loadPer();
    }
  },
  methods: {
    loadPer() {
      const normalizeToArray = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim() === "") return [];
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          // 忽略
        }
        return [];
      };
      this.configKeyspermission = [];
      getExportByUserId({
        name: `exportConfig_permission`,
        competitionId:
          this.userInfo.permission === "超级管理员"
            ? undefined
            : this.eventInfo.id,
      })
        .then((res) => {
          if (res.data.code !== 0 && res.data.result && res.data.result.data) {
            const data = JSON.parse(res.data.result.data);
            this.configKeyspermission = normalizeToArray(data.value);
            if (this.configKeyspermission.includes("dbdmd")) {
              this.menuList.push({
                sort: 14,
                name: "代表队名单",
                path: "/teamStatistic",
                icon: "el-icon-user",
              });
            }
          }
        })
        .catch(() => {
          // 忽略错误
        });
    },
    addOrderToMenu() {
      if (this.menuList && this.menuList.length) {
        this.menuList.forEach((item, index) => {
          if (!item.hasOwnProperty("order")) {
            item.order = index + 1;
          }
        });
      }
    },
    calculateCountdown() {
      //console.log("顶部时间公告", this.eventInfo);
      if (this.eventInfo) {
        const now = moment();
        const target = moment(this.eventInfo.endTime);

        // 如果目标时间已过
        if (target.isBefore(now)) {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
          this.jiezhiTime = "报名已经截至";
          clearInterval(this.timer);
          this.isRunning = false;
          return;
        }

        // 计算差值
        const diff = target.diff(now);
        if (diff > 0) {
          // 转换为天、时、分、秒
          this.days = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.hours = Math.floor(
            (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          this.minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((diff % (1000 * 60)) / 1000);

          this.jiezhiTime = `报名截止时间: ${
            this.days < 10 ? "0" + this.days : this.days
          }天${this.hours < 10 ? "0" + this.hours : this.hours}时${
            this.minutes < 10 ? "0" + this.minutes : this.minutes
          }分${this.seconds < 10 ? "0" + this.seconds : this.seconds}秒`;
        } else {
          this.jiezhiTime = "活动已经截止";
          clearInterval(this.endTimeCountDownTimer);
        }
      } else {
        this.jiezhiTime = "活动已经截止";
        clearInterval(this.endTimeCountDownTimer);
      }
    },
    clickMenuAction() {
      this.collapse = !this.collapse;
    },
    logout() {
      this.$store.dispatch("setUserInfo", null);
      this.$store.dispatch("setEventInfo", null);
      this.$store.dispatch("setUserLogin", false);
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style>
.moduleTitle {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
  min-height: 400px;
}

.el-card__body,
.el-main {
  padding: 0px !important;
}
</style>
<style lang="scss" scoped>
.el-submenu__title {
  text-align: left !important;
}

.el-menu-item {
  text-align: left;
}

.el-submenu {
  text-align: left;
}

.el-icon-menu {
  width: 20px;
  height: 20px;
}

.container_index {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .container_index-header {
    width: 100vw;
    height: 50px;
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 25px;
    background-color: #1e71b1;
    padding-right: 15px;
    padding-left: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    top: 0px;
  }

  .container_index-tol {
    width: 100vw;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px #dddddd solid;
    padding-left: 15px;
    box-shadow: 0 6px 10px -5px rgba(0, 0, 0, 0.05);
    position: fixed;
    left: 0;
    top: 50px;
  }

  .container_index-content {
    width: 100vw;
    height: calc(100vh - 50px - 40px);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    position: fixed;
    left: 0;
    top: 90px;

    .left {
      height: 100%;
      box-shadow: 12px 0 10px -5px rgba(0, 0, 0, 0.05);
      overflow-y: auto;

      .el-menu {
        border: none;
      }
    }

    .right {
      flex: 1;
      height: 100%;
      border-left: 1px #dddddd solid;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      overflow-y: auto;
      padding-bottom: 30px;

      .content {
        width: 100%;

        .content_sc {
          width: 100%;
          padding: 15px;
          min-height: calc(100vh - 170px);
        }
      }
    }
  }
}
</style>
